import { ACCEPT_COOKIE } from '../actions'

export default (prevState = false, { type }) => {
  if (type === ACCEPT_COOKIE) {
    return true
  }
  return prevState
}



// WEBPACK FOOTER //
// ./src/reducers/cookieAccepted.js